import styled from 'styled-components'

export const Container = styled.div`
  .login-info-section {
    background: #28c4d4;

    .login-info-image {
      bottom: 0;
      position: absolute;
      width: 33%;
    }
  }
`
